import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

// Interfaces
import { AddressInterface } from "../../definitions";
import { AddressCardInterface } from './definitions';

const AddressCard: FC<AddressCardInterface> = ({
  ListAddresses,
  choosenAddress,
  setDefaultHandler,
  deleteAddressHandler,
  setChoosenAddress,
  addEditAddress
}) => {
  if (!ListAddresses?.length) return null;

  return (
    <div className="card-wrapper">
      {
        ListAddresses.map((datum: AddressInterface) => {
          const { is_default, alias, full_name, phone_number, address, country, province, city, suburb, postal_code } = datum || {};
          const choosen = choosenAddress?.id === datum.id;
          return (
            <div className={`address-card ${choosen ? "choosen" : ""}`}>
              <div onClick={() => setChoosenAddress(datum)} className={`choose-address-action`}>
                {is_default && <div className="default-address"><p>Default Address</p></div>}

                <p className="place">{alias} - {full_name}</p>
                <p className="phone-number">{phone_number}</p>
                <p className="address">{address}, {suburb}, <span /> {city}, {province}, {postal_code}, {country}</p>
              </div>

              <div className="text-btn">
                {!is_default && <p className="set-default" onClick={() => setDefaultHandler(datum)}>Set as default address</p>}
                <p className="edit" onClick={() => addEditAddress(datum)}>Edit</p>
                {!is_default && <p className="delete" onClick={() => deleteAddressHandler(datum)}>Delete</p>}
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default AddressCard;

